export default __webpack_public_path__ + "static/header-bg-ebecde48eb6434101df84e92b4b0452f.jpg";